/**
 * Block-for-block skeleton for the route page (`/route/:token`): the head
 * (mark, kitchen, stops line, date stamp), then three stop cards (number and
 * name, window and address, Navigate and Call, the door-notes row). Never a
 * "Loading..." string (CLAUDE.md "Loading states").
 */

import { Skeleton } from '@ordo/ui/skeleton'

function StopCardSkeleton() {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border bg-card p-3.5">
      <div className="flex items-start gap-3">
        <Skeleton className="size-[34px] shrink-0 rounded-none" />
        <div className="flex flex-1 flex-col gap-1.5">
          <Skeleton className="h-3 w-3/5" />
          <Skeleton className="h-[18px] w-4/5" />
        </div>
      </div>
      <Skeleton className="h-3.5 w-1/2" />
      <Skeleton className="h-3.5 w-4/5" />
      <div className="flex gap-2">
        <Skeleton className="h-11 flex-1 rounded-full" />
        <Skeleton className="h-11 w-[92px] shrink-0 rounded-full" />
      </div>
      <Skeleton className="h-3.5 w-2/5" />
    </div>
  )
}

export function RoutePageSkeleton() {
  return (
    <div className="min-h-dvh bg-muted/40" aria-busy="true" aria-label="Loading the delivery route">
      <div className="mx-auto flex w-full max-w-[480px] flex-col">
        <header className="flex flex-col gap-3.5 border-b bg-background px-4 pb-4 pt-[18px]">
          <div className="flex items-center justify-between">
            <Skeleton className="h-[18px] w-[60px]" />
            <Skeleton className="h-3.5 w-[110px]" />
          </div>
          <div className="flex items-end justify-between gap-3">
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-3 w-[110px]" />
              <Skeleton className="h-[22px] w-[230px] max-w-full" />
              <Skeleton className="h-3.5 w-full" />
            </div>
            <Skeleton className="h-14 w-[78px] shrink-0 rounded-none" />
          </div>
        </header>
        <main className="flex flex-col gap-3 px-4 py-3.5">
          <StopCardSkeleton />
          <StopCardSkeleton />
          <StopCardSkeleton />
        </main>
      </div>
    </div>
  )
}
